import { GeoJSONPolygon } from "ol/format/GeoJSON";
import { Expose, Type } from "class-transformer";

export class PicassoPicture {
    
  @Type(() => Date)
  @Expose({ name: "scene_date" })
  public sceneDate: Date = new Date();

  @Expose({ name: "collection_id" })
  public collectionId?: string;

  @Expose({ name: "request_id" })
  public requestId?: string;

  public paths: PicassoPaths = new PicassoPaths();

  public status?: string;

  @Type(() => Date)
  public created?: Date;

  @Type(() => Date)
  public updated?: Date;

  @Expose({ name: "task_id" })
  public taskId?: Date;

  @Type(() => Product)
  public product?: Product;

  @Expose({ name: "no_data" })
  public noData: number = 0;

  get link() {
    return  this.paths && this.paths.png ? this.paths.png.link : '';
  }

  get isProcessing() {
    return this.status == 'pending' || this.status == 'retry';
  }

  get isError() {
    return this.status == 'failure' || this.status == 'revoked';
  }

  get isSuccess() {
    return this.status == 'success';
  }

  get rating() {
    switch (true) {
      case this.noData > 90:
        return 0;
      case this.noData > 50:
        return 1;
      case this.noData > 20:
        return 2;
      default:
        return 3;
    }
  }
}

export class PicassoCollection {

  @Type(() => PicassoPicture)
  public pictures: PicassoPicture[] = [];

  @Expose({ name: "bounding_box" })
  public boundingBox?: GeoJSONPolygon;

  get isProcessing() {
    return this.pictures && this.pictures.length > 0 && this.pictures.find(it => it.isProcessing) != undefined;
  }

  get allProducts(): Set<string> {
    const set = new Set<string>();
    this.pictures.forEach(p => {
      if (p.product?.type) {
        set.add(p.product.type);
      }
    });
    return set;
  }

  get hasMultipleProducts(): boolean {
    return this.allProducts.size > 1;
  }

}

export class PicassoPaths {

  public tiff: PicassoPath = new PicassoPath();
  public png: PicassoPath = new PicassoPath();

}

export class PicassoPath {

  @Expose({ name: "s3_path" })
  public s3Ppath: string = '';
  public link: string = '';

}

export class Product {

  public satellite: string = '';

  @Expose({ name: "type_" })
  public type: string = '';

}
